import React from "react";
import ReactApexChart from "react-apexcharts";
import { useTranslation } from "react-i18next";

interface GenderDistribution {
    gender: string;
    count: number;
}

interface GenderDistributionProps {
    data: GenderDistribution[];
}

const GenderDistributionChart: React.FC<GenderDistributionProps> = ({
    data,
}) => {
    const { t } = useTranslation();
    const formatGenderLabel = (value: string) =>
        t(`components.graphs.genderVoteDistribution.series.${value}`, {
            defaultValue: value.replace(/_/g, "/"),
        });
    const gender = data.map((item) => formatGenderLabel(item.gender));
    const count = data.map((item) => item.count);

    const options = {
        chart: {
            type: "bar" as const,
            height: 350,
        },
        series: [
            {
                name: t("components.graphs.genderDistribution.seriesLabel"),
                data: count,
            },
        ],
        plotOptions: {
            bar: {
                borderRadius: 0,
                horizontal: true,
                distributed: true,
                barHeight: "80%",
                isFunnel: true,
            },
        },
        colors: ["#D549CD", "#5DC6FF", "#7C9EFF"],
        dataLabels: {
            enabled: true,
            formatter: function (val: any, opt: any) {
                return opt.w.globals.labels[opt.dataPointIndex] + ":  " + val;
            },
            dropShadow: {
                enabled: true,
            },
        },
        xaxis: {
            categories: gender,
        },
        legend: {
            show: true,
            position: "bottom" as const,
        },
        title: {
            align: "center" as const,
            margin: 10,
            offsetX: 0,
            offsetY: 0,
            floating: false,
            style: {
                fontSize: "18px",
                color: "#263238",
            },
        },
    };

    return (
        <>
            <ReactApexChart
                options={options}
                series={options.series}
                type="bar"
                height={350}
            />
        </>
    );
};

export default GenderDistributionChart;
